import { db, DB_ID, PARK_INPUTS_TABLE_ID, query } from "@/appwrite";
import { ParkInput, HookResponse, Employee } from "@models/Models";
import useImage from "./useImage";
import useEmployee from "./useEmployee";

const useParkInputs = () => {
    const { getPublicURL } = useImage();
    const { getEmployeeById } = useEmployee();

    const getAllParkInputs = async (limit: number, offset: number = 0): Promise<HookResponse> => {
        try {
            const response = await db.listRows({
                databaseId: DB_ID,
                tableId: PARK_INPUTS_TABLE_ID,
                queries: [
                    query.limit(limit),
                    query.orderDesc("$createdAt"),
                    query.offset(offset)
                ]
            });

            // Fetch image URLs for each park input
            const parkInputs: ParkInput[] = await Promise.all(response.rows.map(async (item) => {
                const imageURLResponse = await getPublicURL(item.image);
                const signatureURLResponse = await getPublicURL(item.signature);

                let imageURL = "";
                let signatureURL = "";
                let employee: Employee = item.creator;

                if(imageURLResponse.success){
                    imageURL = imageURLResponse.data;
                }

                if(signatureURLResponse.success){
                    console.log("Could not find image: ", item.signature);
                    signatureURL = signatureURLResponse.data;
                };

                if(item.creator) {
                    const employeeResult = await getEmployeeById(item.creator);

                    if(employeeResult.success) {
                        console.log(employeeResult.data)
                        employee = employeeResult.data
                    }
                }

                return {
                    $id: item.$id,
                    status: item.status,
                    topNummer: item.topNummer,
                    creator: employee,
                    firstSMSsentAt: item.firstSMSsentAt,
                    image: imageURL,
                    project: item.project,
                    address: item.address,
                    signature: signatureURL,
                    loadingZone: item.loadingZone,
                    phoneNumber: item.phoneNumber,
                    secondSMSsendAt: item.secondSMSsendAt,
                    vehiclePlate: item.vehiclePlate,
                    endetAt: item.endetAt,
                };
            }));

            return {
                success: true,
                message: "Park inputs retrieved successfully",
                data: parkInputs as ParkInput[],
                total: response.total
            };

        } catch (error: any) {
            return {
                success: false,
                message: error.message,
            };
        }
    };

    const getAllParkInputsByProject = async (limit: number, offset: number = 0, projectId: string): Promise<HookResponse> => {
        try {
            const response = await db.listRows({
                databaseId: DB_ID,
                tableId: PARK_INPUTS_TABLE_ID,
                queries: [
                    query.equal("project", projectId),
                    query.limit(limit),
                    query.orderDesc("$createdAt"),
                    query.offset(offset)
                ]
            });

            // Fetch image URLs for each park input
            const parkInputs: ParkInput[] = await Promise.all(response.rows.map(async (item) => {
                const imageURLResponse = await getPublicURL(item.image);
                const signatureURLResponse = await getPublicURL(item.signature);

                let imageURL = "";
                let signatureURL = "";
                let employee: Employee = item.creator;

                if(imageURLResponse.success){
                    imageURL = imageURLResponse.data;
                }

                if(signatureURLResponse.success){
                    console.log("Could not find image: ", item.signature);
                    signatureURL = signatureURLResponse.data;
                };

                if(item.creator) {
                    const employeeResult = await getEmployeeById(item.creator);

                    if(employeeResult.success) {
                        console.log(employeeResult.data)
                        employee = employeeResult.data
                    }
                }

                return {
                    $id: item.$id,
                    status: item.status,
                    topNummer: item.topNummer,
                    creator: employee,
                    firstSMSsentAt: item.firstSMSsentAt,
                    image: imageURL,
                    project: item.project,
                    address: item.address,
                    signature: signatureURL,
                    loadingZone: item.loadingZone,
                    phoneNumber: item.phoneNumber,
                    secondSMSsendAt: item.secondSMSsendAt,
                    vehiclePlate: item.vehiclePlate,
                    endetAt: item.endetAt,
                };
            }));

            return {
                success: true,
                message: "Park inputs retrieved successfully",
                data: parkInputs as ParkInput[],
                total: response.total
            };

        } catch (error: any) {
            return {
                success: false,
                message: error.message,
            };
        }
    };

    return {
        getAllParkInputs,
        getAllParkInputsByProject
    }
};

export default useParkInputs;